import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { getSrcString, getSrcSetString } from '../helpers/getSrcStrings';
import { SeoLink } from 'dibs-seo/exports/SeoLink';

import styles from './HpRespPromoModulePromoItemOld.scss';

function HpRespPromoModulePromoItemOld({ promotion, className, onClick }) {
    const { mobileImageUrl, imageUrl, linkData } = promotion;
    const uid = useUID() || undefined;
    const promoItemId = `promomodulepromo-${uid}`;
    const itemClassNames = classnames(styles.item, className);

    const shownImageUrl = imageUrl || mobileImageUrl;

    return (
        <div className={itemClassNames}>
            {promotion.imageCopy && (
                <span id={promoItemId} className={styles.imageCopy}>
                    {promotion.imageCopy}
                </span>
            )}
            <SeoLink
                linkData={linkData}
                className={styles.link}
                onClick={onClick}
                ariaLabel={promotion.cta}
                ariaDescribedBy={promotion.imageCopy ? promoItemId : undefined}
            >
                <img
                    aria-hidden="true"
                    className={styles.image}
                    src={getSrcString({ url: shownImageUrl })}
                    srcSet={getSrcSetString({
                        url: shownImageUrl,
                        widths: [400, 640, 960, 1280, 1440],
                    })}
                />
            </SeoLink>
        </div>
    );
}

HpRespPromoModulePromoItemOld.propTypes = {
    promotion: PropTypes.shape({
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        imageHeight: PropTypes.string,
        alignment: PropTypes.string,
        cta: PropTypes.string,
        imageCopy: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

HpRespPromoModulePromoItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespPromoModulePromoItemOld };
